import LoginSlideshow from './LoginSlideshow';

const PAPER_BG = '#F7F5F0';

/**
 * Left column only (paper background). Used when a parent already renders LoginSlideshow.
 */
export function AuthMarketingLeftColumn({ className, children }) {
  return (
    <div className={className} style={{ backgroundColor: PAPER_BG }}>
      {children}
    </div>
  );
}

/**
 * Full marketing split: left content + right LoginSlideshow (single place for funnel routes in App).
 */
export function AuthMarketingSplitLayout({ leftColumnClassName, children }) {
  return (
    <div
      className="flex min-h-screen w-full"
      style={{ backgroundColor: PAPER_BG }}
    >
      <AuthMarketingLeftColumn className={leftColumnClassName}>{children}</AuthMarketingLeftColumn>
      <div className="hidden lg:block lg:w-1/2 relative">
        <LoginSlideshow />
      </div>
    </div>
  );
}

/** Centered spinner + optional copy for loading / redirecting states */
export function AuthMarketingLoadingState({ title, description }) {
  const bodyText = description ?? (!title ? 'Loading...' : null);
  return (
    <div className="text-center space-y-4">
      <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-[#6B8E6B] border-r-transparent" />
      {title ? (
        <p className="text-lg font-medium" style={{ color: '#3A3429' }}>
          {title}
        </p>
      ) : null}
      {bodyText ? (
        <p className="text-sm" style={{ color: '#6B6458' }}>
          {bodyText}
        </p>
      ) : null}
    </div>
  );
}

/** Default export: same as AuthMarketingSplitLayout (legacy name AuthMarketingShell). */
export default AuthMarketingSplitLayout;
